<template>
  <v-app id="inspire">
    <Bar
      :activeLang="activeLang"
      @changeLang="toggleLang()"
      :leftMenu="leftMenu"
      :rightMenu="rightMenu"
     />
    <router-view
      :lang="activeLang"
    />

    <v-footer
      class="justify-center"
      color="isYellow"
    >
      <v-container>
        <v-row
          no-gutter
        >
          <v-col class="d-none d-md-block" md="4">
            <v-img
              src="img/footer/BMBF_gefoerdert_Logo.png"
              max-height="219"
              max-width="305"
            />
          </v-col>
          <v-col md="4" style="text-align:center;">
            <v-btn text class="footerLink" :href="de?'https://www.dsm.museum/impressum-datenschutz-agb/#datenschutz':'https://www.dsm.museum/en/legal-notice'">
              {{de?'Datenschutz':'legal notice'}}
            </v-btn><br v-if="de" />
            <v-btn v-if="de" text class="footerLink" href="https://www.dsm.museum/impressum-datenschutz-agb/#impressum">
              Impressum
            </v-btn><br /><br />
            <span class="isBlueBG isYellowTXT vonBis text-h6 font-weight-bold">
              {{de?'vom 3.4. bis 3.10.2021':'from April 3rd until October 3rd, 2021'}}
            </span>
            <p class="text-uppercase" v-if="de">ist die ausstellung im <br />deutschen schifffahrtsmuseum <br >zu sehen</p>
            <p class="text-uppercase" v-if="en">
              the exhibition can be seen in the <br /> german maritime museum <br></p>
          </v-col>
          <v-col md="4" class="text-right d-none d-md-block">
            <img
              src="img/footer/HERA_Logo.png"
              style="max-width: 100%; width:300px;"
            /><br />
            <img
              src="img/footer/OldenburgUniversity_Logo.png"
              style="max-width: 100%; width:350px;margin-top:30px;"
            />
          </v-col>
        </v-row>
        <v-row
          justify="center" align="center"
        >
          <v-col cols="6" class="d-md-none text-center">
            <img
                src="img/footer/BMBF_gefoerdert_Logo.png"
                style="max-height:219px;max-width:100%"
            />
          </v-col>
          <v-col cols="6" class="d-md-none text-center">
            <img
                src="img/footer/HERA_Logo.png"
                style="max-width: 100%; width:300px;"
            /><br />
            <img
                src="img/footer/OldenburgUniversity_Logo.png"
                style="max-width: 100%; width:350px;margin-top:30px;"
            />
          </v-col>
          <v-col cols="6" md="3" class="text-center">
            <img
              src="img/footer/AltesGymnasium_Logo.png"
              style="max-width: 100%; width:200px;"
            />
          </v-col>
          <v-col cols="6" md="3" class="text-center">
            <img
              src="img/footer/Caecilienschule_Logo.png"
              style="max-width: 100%; width:410px;"
            />
          </v-col>
          <v-col cols="6" md="3" class="text-center">
            <img
              src="img/footer/StockholmUniversity_Logo.png"
              style="max-width: 100%; width:220px;"
            />
          </v-col>
          <v-col cols="6" md="3" class="text-center text-md-right">
            <img
              src="img/footer/SheffieldUniversity_Logo.png"
              style="max-width: 100%; width:374px;"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>
<style>

  @font-face {
    font-family: 'Montserrat';
    font-style: normal;
    src: local('Montserrat'), url(./fonts/Montserrat-VariableFont_wght.ttf) format('truetype');
  }

  .col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
      width: 100%;
      padding: 12px 20px;
  }
  .theme--light.v-application, .theme--light.v-sheet {
    background: #FFFFFF;
    color: var(--v-isBlack-base) !important;
  }
  .theme--light.v-application .text--primary, .theme--light.v-btn {
    color: var(--v-isBlack-base) !important;
  }
  .theme--light.v-application .text--secondary {
    color: var(--v-isBlack-base) !important;
    opacity: 0.6 !important;
  }
  .theme--light.v-application .text--disabled {
    color: var(--v-isBlack-base) !important;
    opacity: 0.38 !important;
  }
  .footerLink{
    text-transform: uppercase;
    color: var(--v-isBlack-base);
  }
  main{
    background-image: url('/rauschmittel/img/DSM_bgBildCropped.png');
    background-repeat: repeat;
  }
  .isBlueBG{
    background-color: var(--v-isBlue-base);
  }
  .isBlueTXT{
    color: var(--v-isBlue-base);
  }
  .isRedBG{
    background-color: var(--v-isRed-base);
  }
  .isRedTXT{
    color: var(--v-isRed-base);
  }
  .isYellowBG{
    background-color: var(--v-isYellow-base);
  }
  .isYellowTXT{
    color: var(--v-isYellow-base);
  }
  .isboxHLTXT{
    color: var(--v-boxHL-base);
  }
  .colorBox{
    margin-bottom:40px;
    padding-bottom:50px;
  }
  .vonBis{
    padding: 5px 18px;
    text-transform: uppercase;
    display: inline-block;
    line-height: 100% !important;
    margin-bottom:10px;
  }
</style>
<script>
import Bar from './components/Bar'
export default {
  name: 'App',
  components: {
    Bar
  },
  data () {
    return {
      activeLang: navigator.language.split('-')[0],
      leftMenu: [
        {
          de: 'Karte',
          en: 'Map',
          to: '#mapC'
        },
        {
          de: 'Objekte',
          en: 'Objects',
          to: '#objectsC'
        },
        {
          de: 'Beteiligte',
          en: 'Credits',
          to: '#creditsC'
        }
      ],
      rightMenu: [
        {
          de: 'Filme',
          en: 'Movies',
          to: '#moviesA'
        },
        {
          de: 'Objekte',
          en: 'Objects',
          to: '#objectsA'
        },
        {
          de: 'Beteiligte',
          en: 'Credits',
          to: '#creditsA'
        }
      ]
    }
  },
  computed: {
    isMobile () {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    de () {
      return this.activeLang === 'de';
    },
    en () {
      return this.activeLang !== 'de';
    }
  },
  methods: {
    toggleLang () {
      this.activeLang === 'de' ? this.activeLang = 'en' : this.activeLang = 'de'
    }
  }
}
</script>
